// Types
import type { IPatchResourceModel, TPatchDataClient } from '~/misc/patch/types';

// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { PatchModel } from '~/misc/patch/models';

export class PatchDataClient
  extends AbstractDataClient<IPatchResourceModel>
  implements TPatchDataClient
{
  constructor() {
    super(new PatchModel());
  }
}
